import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Store } from '@ngxs/store';
import { UtilsService } from '@shared/providers/utils.service';
import { SetUserEditIsEditing } from '@shared/store/edit/edit.actions';
import { CPFValidator } from '@shared/validators/cpf.validator';
import { PhoneValidator } from '@shared/validators/phone.validator';

@Component({
  selector: 'app-personal-information-form',
  templateUrl: './personal-information-form.component.html',
  styleUrls: ['./personal-information-form.component.scss'],
})
export class PersonalInformationFormComponent implements OnInit {
  @Input() personalInformations: any;
  @Input() showButton = true;
  @Input() showPhoto = true;
  @Output() submitForm: EventEmitter<any> = new EventEmitter<any>();

  public personalInformationsForm: FormGroup;
  public editMode = false;

  constructor(
    private formBuilder: FormBuilder,
    private utils: UtilsService,
    private store: Store,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.personalInformationsForm = this.initializeForm();

    if (this.personalInformations) {
      this.personalInformationsForm.patchValue(this.personalInformations);

      if (this.personalInformations?.userDocument) {
        this.userDocument.setValue(
          this.personalInformations.userDocument.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        );
      }
      if (this.personalInformations?.userPhone) {
        // Aplica a máscara do telefone ( (XX) XXXXX-XXXX )
        this.userPhone.setValue(
          this.personalInformations.userPhone
            .replace(/\D/g, '')
            .slice(0, 11)
            .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
        );

        if (this.personalInformations.userPhone.length === 10) {
          this.userPhone.setValue(
            this.personalInformations.userPhone
              .replace(/\D/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
          );
        }
      }

      this.userEmail.disable();
      this.editMode = true;
    }

    this.store.dispatch(new SetUserEditIsEditing(false));
  }

  initializeForm(): FormGroup {
    return this.formBuilder.group({
      userName: ['', Validators.compose([Validators.required, Validators.maxLength(90)])],
      userDocument: ['', Validators.compose([Validators.required, CPFValidator.isValid])],
      userPhone: ['', Validators.compose([Validators.required, PhoneValidator.isValid])],
      userEmail: ['', Validators.compose([Validators.required, Validators.email, Validators.maxLength(90)])],
      userPhotoUrl: [''],
      userResponsibleCreci: ['', Validators.compose([Validators.maxLength(20)])],
    });
  }

  get userName() {
    return this.personalInformationsForm.get('userName');
  }

  get userDocument() {
    return this.personalInformationsForm.get('userDocument');
  }

  get userPhone() {
    return this.personalInformationsForm.get('userPhone');
  }

  get userEmail() {
    return this.personalInformationsForm.get('userEmail');
  }

  get userPhotoUrl() {
    return this.personalInformationsForm.get('userPhotoUrl');
  }

  get userResponsibleCreci() {
    return this.personalInformationsForm.get('userResponsibleCreci');
  }

  public submit(form: FormGroup) {
    if (form.invalid) {
      this.utils.validateAllFields(form);
      this.utils.showToast('', `${this.translate.instant('COMPONENTS.FORMS.CHECK_THE_FIELDS')}`);
    } else {
      const rawValue = form.getRawValue();
      rawValue.userPhone = this.utils.unmask(rawValue.userPhone);
      rawValue.userDocument = this.utils.unmask(rawValue.userDocument);
      this.submitForm.emit(rawValue);
    }
  }

  setPhotoValue(event) {
    this.userPhotoUrl.setValue(event);
  }
}
